var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgHorizontalPoints = function SvgHorizontalPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.417 11a1.833 1.833 0 11-3.667 0 1.833 1.833 0 013.667 0zM11 12.833a1.833 1.833 0 100-3.666 1.833 1.833 0 000 3.666zm6.417 0a1.833 1.833 0 100-3.666 1.833 1.833 0 000 3.666z"
  })));
};
export default SvgHorizontalPoints;